// This file is auto-generated by @hey-api/openapi-ts

import * as z from "zod";

export const ApiSuccess = z.object({
    status: z.int(),
    success: z.literal(true),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type ApiSuccess = z.infer<typeof ApiSuccess>;

export const ApiError = z.object({
    status: z.int(),
    success: z.literal(false),
    error: z.string(),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type ApiError = z.infer<typeof ApiError>;
